import './App.css';
import {
  createBrowserRouter,
  Route,
  RouterProvider,
} from "react-router-dom";

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './services/store';

import RouteLayout from "./services/routeLayout";
import About from './pages/about';
import Home from './pages/home';
import Checkout from './pages/checkout';
import Admin from './pages/admin';
import Shop from './pages/shop';
import Contact from './pages/contact';
import Product from './pages/product';
import OrderConfirmation from './components/checkout/OrderConfirmation';
import Heirloom from './pages/create';

const routes = [
  {
    Path: "/",
    element: <RouteLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "/shop",
        element: <Shop />,
      },
      {
        path: "/shop/:category",
        element: <Shop />,
      },
      {
        path: "/checkout",
        element: <Checkout />,
      },
      {
        path: "/admin",
        element: <Admin />,
      },
      {
        path: "/product/:id",
        element: <Product />,
      },
      {
        path: "/order-confirmation",
        element: <OrderConfirmation />,
      },
      {
        path: "/heirloom",
        element: <Heirloom />,
      },
    ],
  },
]



function App() {
  const router = createBrowserRouter(routes)
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <RouterProvider router={router}>
        {routes.map((route) => (
          <Route key={route.path} path={route.path} element={route.element}>
            {route.children}
          </Route>
        ))}
      </RouterProvider>
    </PersistGate>
  </Provider>
  );
}

export default App;
